import React, { useEffect, useState } from 'react';
import { Button, Container } from '@mui/material';
import { dispatch, useSelector } from '../../../../redux/store';
import { PATH_DASHBOARD } from '../../../../routes/paths';
import useSettings from '../../../../hooks/useSettings';
import Page from '../../../../components/Page';
import Iconify from '../../../../components/Iconify';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../../components/table/DataGridTable';
import { accessVerify, capitalize } from '../../../../utils/common';
import { fCurrency } from '../../../../utils/formatNumber';
import PermissionRequired from '../../../errorPages/permissionRequired';
import { getLocations } from '../../../../redux/slices/settingsManagementRedux/locationsRedux';
import { getAllPickmeFoodList, syncFoodListWithPickme } from '../../../../redux/slices/saleRedux/pickmeFoodListRedux';

export default function PickmeFoodList() {
  const dataModel = {
    name: '',
    locationId: '',
    key: '',
  };
  const [selectedDataObj, setSelectedDataObj] = useState(dataModel);
  const { themeStretch } = useSettings();
  const [pickmeFoodLists, setpickmeFoodLists] = useState([]);

  const { allData, addData } = useSelector((state) => state.pickmeFoodList);
  let locationData;
  ({ data: locationData } = useSelector((state) => state.location));

  useEffect(() => {
    dispatch(getAllPickmeFoodList());
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    setpickmeFoodLists(
      allData?.map((value) => {
        return {
          ...value,
        };
      })
    );
  }, [allData]);

  useEffect(() => {
    if (addData?.data) {
      dispatch(getAllPickmeFoodList());
    }
  }, [addData]);

  const updateEditingData = (key, value) => {
    setSelectedDataObj({
      ...selectedDataObj,
      [key]: value,
    });
  };

  const columns = !pickmeFoodLists?.[0]
    ? []
    : Object.keys(pickmeFoodLists?.[0])
        .map((value) => {
          if ([].includes(value)) {
            return {};
          } else if (value === 'depreciatedAmountPerDay') {
            return {
              accessorKey: 'totalValue',
              header: 'Depreciated Amount Per Day',
              Cell: ({ cell, row }) => {
                return fCurrency(row?.original?.depreciatedAmountPerDay);
              },
            };
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);

  return (
    <Page title={`Pickme Food List`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`Pickme Food List`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Pickme',
              href: '',
            },
            { name: `Pickme Food List` },
          ]}
          action={
            <Button
              variant='contained'
              startIcon={<Iconify icon='material-symbols:sync' />}
              onClick={() => {
                dispatch(syncFoodListWithPickme());
              }}
            >
              Sync Now
            </Button>
          }
        />

        {accessVerify('SUPER_ADMIN') ? (
          <DataGridTable
            name={'PickMe Food List'}
            data={pickmeFoodLists}
            column={columns}
            onRowClick={(row) => {}}
            isRowClickable={true}
            isLoading={false}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableRowSelection={false}
            enableRowActions={false}
            renderRowActionItems={(value, closeMenu) => []}
          />
        ) : (
          <PermissionRequired />
        )}
      </Container>
    </Page>
  );
}
